
export const formFields = {
    advertiserId: {
      key: 'advertiserId',
      label: 'Advertiser',
      required: true,
      placeholder: '',
      requiredMessage: 'This field is required.',
      displayLayout: 'col-md-12',
      valueKey: 'key',
      textKey: 'value',
      tooltip: '<div> Advertiser </div>'
    },
    addTypeGoogle: {
      key: 'addTypeGoogle',
      label: '',
      placeholder: '',
      required: true,
      displayLayout: 'col-sm-12',
      requiredMessage: 'This field is required.',
      options: [{ id: 1, value: 'Manually Enter Account Details', checked: false },
      { id: 0, value: 'Link Google Account', checked: false }],
    },
    addTypeFacebook: {
      key: 'addTypeFacebook',
      label: '',
      placeholder: '',
      required: true,
      displayLayout: 'col-sm-12',
      requiredMessage: 'This field is required.',
      options: [{ id: 1, value: 'Manually Enter Account Details', checked: false },
      { id: 0, value: 'Link Facebook Account', checked: false }],
    },
    platform: {
      key: 'platform',
      type: 'checkboxGroup',
      label: 'Select Platform',
      required: true,
      requiredMessage: 'This field is required.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Devices Supported </div>',
      valueKey: 'checked',
      textKey: 'value'
    },
    addTypeIon: {
      key: 'addTypeIon',
      label: '',
      placeholder: '',
      required: true,
      displayLayout: 'col-sm-12',
      requiredMessage: 'This field is required.',
      options: [{ id: 1, value: 'Use Infomo', checked: false },
      { id: 0, value: 'Link ION Account', checked: true }],
    },
    addTypeDv360: {
      key: 'addTypeDv360',
      label: '',
      placeholder: '',
      required: true,
      displayLayout: 'col-sm-12',
      requiredMessage: 'This field is required.',
      options: [{ id: 1, value: 'Use Infomo', checked: false },
      { id: 0, value: 'Link DV 360 Account', checked: false }],
    },
    addTypeGam: {
      key: 'addTypeGam',
      label: '',
      placeholder: '',
      required: true,
      displayLayout: 'col-sm-12',
      requiredMessage: 'This field is required.',
      options: [{ id: 1, value: 'Manually Enter Account Details', checked: false },
      { id: 0, value: 'Link Gam Account', checked: false }],
    }
  };

  export const accountOptions = [
    { value: "account1", label: "Account1", color: "#00B8D9" },
    { value: "account2", label: "Account2", color: "#00B8D9" },
    { value: "account3", label: "Account3", color: "#00B8D9" },
    { value: "account4", label: "Account4", color: "#00B8D9" },
    { value: "account5", label: "Account5", color: "#00B8D9" },
    { value: "account6", label: "Account6", color: "#00B8D9" }
  ];
  
  
  export const googleAdsFields = {
    googleMasterAccountID: {
      key: 'googleMasterAccountID',
      type: 'text',
      label: 'Master Account ID (MCC)',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      maxLength: 50,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Master Account ID (MCC) </div>',
      pattern: /^\d{0,100}$/
    },
    googleAdvertiserID: {
      key: 'googleAdvertiserID',
      type: 'text',
      label: 'Advertiser ID (CID)',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Advertiser ID (CID) </div>',
      pattern: /^\d{0,100}$/
    },
  
    googleCurrency: {
      key: 'googleCurrency',
      label: 'Currency',
      placeholder: '',
      type: "text",
      displayLayout: 'col-md-7',
      valueKey: 'key',
      required: true,
      requiredMessage: 'This field  is required.',
      textKey: 'value',
      tooltip: '<div>  Currency </div>',
      pattern: /^[A-Z]*$/
    }
  }
  
  export const facebookFormFields = {
    fbAccountID: {
      key: 'fbAccountID',
      label: 'Account ID',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Master Account ID (MCC) </div>',
      pattern: /^\d{0,100}$/
    },
    fbCurrency: {
      key: 'fbCurrency',
      label: 'Currency',
      placeholder: '',
      type: "text",
      displayLayout: 'col-md-7',
      valueKey: 'key',
      required: true,
      requiredMessage: 'This field  is required.',
      textKey: 'value',
      tooltip: '<div>  Currency </div>',
      pattern: /^[A-Z]*$/
    },
  }
  
  export const dvFormFileds = {
    dv360Currency: {
      key: 'dv360Currency',
      label: 'Currency',
      placeholder: '',
      type: "text",
      displayLayout: 'col-md-7',
      valueKey: 'key',
      required: true,
      requiredMessage: 'This field  is required.',
      textKey: 'value',
      tooltip: '<div> Currency </div>',
      pattern: /^[A-Z]*$/
    },
    dv360AccountID: {
      key: 'dv360AccountID',
      label: 'Account ID',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Account ID </div>',
      pattern: /^\d{0,100}$/
    },
  }
  
  export const ionFormFileds = {
    ionAccountID: {
      key: 'ionAccountID',
      label: 'Account ID',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-7',
      tooltip: '<div> Account ID </div>',
      pattern: /^\d{0,100}$/
    },
    ionCurrency: {
      key: 'ionCurrency',
      label: 'Currency',
      placeholder: '',
      type: "text",
      displayLayout: 'col-md-7',
      valueKey: 'key',
      required: true,
      requiredMessage: 'This field  is required.',
      textKey: 'value',
      tooltip: '<div>  Currency </div>',
      pattern: /^[A-Z]*$/
    },
  }
  
  export const confirmationMessage = {
    action: {
      confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
      type: 'Confirmation'
    }
  }
  
  export const successfullyMessage = {
    action: {
      confirmationMessage: 'Successfully Saved Advertiser Details',
      type: 'Success',
    }
  }
  export const platformtype = [
    { key: '1', value: 'Google Adwords', checked: false, disabled: false },
    { key: '2', value: 'Facebook', checked: false, disabled: false },
    { key: '3', value: 'ION', checked: false, disabled: false },
    { key: '4', value: 'DV 360', checked: false, disabled: false },
    { key: '5', value: 'GAM', checked: false, disabled: true },
    { key: '6', value: 'TikTok', checked: false, disabled: false },
  ]
  
  export const dvPlatform = [
    { id: '1', key: 'linkAccount', value: "Link My Account" },
    { id: '2', key: 'useInfo', value: "Use My Info" },
  ]
  
  export const IONplatform = [
    { key: '1', value: 'Link my Account', checked: false },
    { key: '2', value: 'Use my info', checked: false },
  ]
  
  // export const options = [
  //   { text: 'bug', id: 1 },
  //   { text: 'feature', id: 2 },
  //   { text: 'documents', id: 3 },
  //   { text: 'discussion', id: 5 },
  // ];